export default {
  test: 'test',
  logout_label: 'Disconnessione',
  hello: 'ciao',
  ciao: 'ciao',
  Username: 'Nome utente'
}
